import { render, staticRenderFns } from "./ApiKeysIntegracoesForm.vue?vue&type=template&id=969cba84&"
import script from "./ApiKeysIntegracoesForm.vue?vue&type=script&lang=js&"
export * from "./ApiKeysIntegracoesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports